import { FC } from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import Button from 'components/Button';

const MentorButtonRoutes: FC<{ mentorId: number | undefined }> = ({
  mentorId,
}) => {
  return (
    <Routes>
      <Route
        path=""
        element={
          <Link to={`/admin/mentoring/mentors/${mentorId}/edit-information`}>
            <Button variant="outlined">
              Modifier les informations générales
            </Button>
          </Link>
        }
      />

      {/* 
			DISABLED
			<Route path="form" element={
				<Button variant='outlined'>
					Modifier le formulaire
				</Button>
			} /> */}
    </Routes>
  );
};

export default MentorButtonRoutes;
